export class TouchBlocker {
  private isDismissing = false;
  private touchStartHandler?: (event: TouchEvent) => void;
  private isListening = false;

  public setDismissing(): void {
    this.isDismissing = true;

    if (!this.isListening) {
      this.startListening();
    }
  }

  public destroy(): void {
    this.stopListening();
  }

  private startListening(): void {
    if (!this.isListening) {
      this.touchStartHandler = this.onTouchStart.bind(this);
      document.addEventListener('touchstart', this.touchStartHandler, { passive: false });
      this.isListening = true;
    }
  }

  private stopListening(): void {
    if (this.isListening && this.touchStartHandler) {
      document.removeEventListener('touchstart', this.touchStartHandler);
      this.touchStartHandler = undefined;
      this.isListening = false;
    }
  }

  private onTouchStart(event: TouchEvent): void {
    if (this.isDismissing) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
